module.exports = "/_next/static/images/illustration_contact-f175b8838282388808b7ae16de7a73ef.svg";